module.exports = __webpack_public_path__ + "img/work-shifts.6ba5d04d.svg";